import { clubfinderApi, clubfinderCdnApi } from "~/utils/axios.util";

export interface IReviewStatistic {
    Aantal: number;
    GemiddeldeScore: number;
    AanbevelingsPercentage: number;
    Antwoorden: IReviewAntwoord[];
}

export interface IReviewAntwoord {
    Id: number;
    Review: number;
    ReviewVraag: number;
    Titel: string;
    Antwoord: number;
    DateCreated: Date;
}

export interface IReview {
    Antwoorden: IReviewAntwoord[];
    Id: number;
    EntityType: number;
    EntityId: string;
    Value: number;
    Title: string;
    Description: string;
    Recommend: boolean;
    Approved: boolean;
    Alias: string;
    DateCreated: string; // ISO date string
    Source: string;
    SportaanbiederNaam: string;
    SportaanbiederFoto: string;
    SportaanbiederIdentifier: string;
    SportaanbiederIndex: number;
    SportaanbiederSlug: string;
}

export interface IReviewVraag {
    Id: number;
    Vraag: string;
    Titel: string;
    Actief: boolean;
    Order: number;
    DateCreated: string; // ISO string van de datum
    Antwoord: number | null
}

export interface ICreateReview {
    Approved: boolean;
    Recommend: boolean | null;
    Title: string;
    Description: string;
    Alias: string;
    Email: string;
    EntityType: string;
    EntityId?: string;
    SportactiviteitId?: number;
    Antwoorden: { ReviewVraag: number; Antwoord: number | null }[];
    Source: string;
    Platform: number;
}

class ReviewRepository {
    async getReviewStatistics(entityId: string, entityType: string) {
        const response = await clubfinderCdnApi.get<IReviewStatistic>('/api/review/GetReviewStatsistc', {
            params: {
                entityId: entityId,
                entityType: entityType,
            }
        })

        return response.data
    }

    async getSportaanbiederReviewsMetAntwoorden(sportaanbieder: string, count: number, includeDenied?: boolean) {
        const response = await clubfinderCdnApi.get<IReview[]>('api/review/GetSportaanbiederReviewsMetAntwoorden', {
            params: {
                entityid: sportaanbieder,
                count: count,
                includeDenied: includeDenied || false,
            }
        })

        return response.data
    }

    async getReviewVragen() {
        const response = await clubfinderApi.get<IReviewVraag[]>('api/reviewvraag')
        return response.data
    }

    async getAlReviewAchtergelaten(entityId: string, entityType: string, email: string) {
        const response = await clubfinderCdnApi.get<IReview[]>('api/review/GetAlReviewAchtergelaten', {
            params: {
                entityid: entityId,
                entityType: entityType,
                email: email,
            }
        })

        return response.data
    }

    async createReview(review: ICreateReview) {
        const response = await clubfinderApi.post('api/review/reviewwithantwoorden', review);

        return response.data;
    }
}

export default new ReviewRepository();